import Vue from 'vue'

// State
const state = {
  isLoading: false,
  data: null
}

// Mutations
const fetchDashboardDataRequest = 'fetchDashboardDataRequest'
const fetchDashboardDataResponse = 'fetchDashboardDataResponse'

const mutations = {
  [fetchDashboardDataRequest] (state) {
    state.isLoading = true
  },
  [fetchDashboardDataResponse] (state, data) {
    state.isLoading = false
    state.data = data
  }
}

// Actions
export const fetchDashboardData = 'fetchDashboardData'
const actions = {
  [fetchDashboardData]: ({ commit }) => {
    commit(fetchDashboardDataRequest)
    return Vue.http.get(`${SERVER_URL}/dashboard`).then(({ data }) => {
      commit(fetchDashboardDataResponse, data)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js